<template>
  <div class="tabs">
    <div class="tabs__switch-list-wrap">
      <div class="tabs__switch-list">
        <label
          v-for="tabName in tabs"
          :key="tabName"
          :class="[
            'tabs__switch',
            {
              'tabs__switch--active': tabName === activeTab,
            },
          ]"
        >
          <input v-model="activeTab" type="radio" :value="tabName" />
          {{ tabName }}
        </label>
      </div>
    </div>

    <div class="tabs__content">
      <div
        v-for="tab in $slots.default"
        :key="tab.key"
        :class="['tabs__tab', { 'tabs__tab--active': tab.key === activeTab }]"
      >
        <vnode :node="tab" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Tabs',

  props: {
    tabs: {
      type: Array,
      required: true,
    },
    value: {
      type: String,
      default: null,
    },
  },

  computed: {
    activeTab: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },

  created() {
    if (!this.activeTab) this.activeTab = this.tabs[0];
  },
};
</script>

<style lang="scss">
.tabs {
  &__switch-list {
    border-radius: 6px;
    padding: 5px;
    height: 45px;
    line-height: 35px;
    width: fit-content;
  }

  &__switch {
    position: relative;
    display: inline-block;
    height: 100%;
    padding: 0 48px;
    font-size: 14px;
    color: #71829b;
    cursor: pointer;
    border-radius: 6px;

    &:not(:first-child):before {
      position: absolute;
      left: 0;
      display: inline-block;
      height: 22px;
      width: 2px;
      background: #a7a9ac;
      transform: translateY(6px);
      content: '';
    }

    input {
      position: absolute;
      width: 0;
    }

    &:hover {
      background-color: darken(#ecf1f8, 10%);
    }

    &:hover::before,
    &:hover + &::before {
      display: none;
    }

    &--active {
      background-color: #fff;
    }

    &.tabs__switch--active::before,
    &--active + &::before {
      display: none;
    }
  }

  &__tab:not(&__tab--active) {
    display: none;
  }
}
</style>
